import { buildTranslate } from 'locales'
import { UserCountMetric } from 'models/CampaignMetric'
import React from 'react'
import AudienceBreakoutModalv3 from 'scenes/CampaignCenter/Builder/Steps/Shared/Review/components/Audience/components/AudienceBreakoutModalv3'

const t = buildTranslate(
  'thanx_campaigns.review.customers.message.breakout_modal'
)

type Props = {
  show: boolean
  includeRecentlyRewarded?: boolean
  userCountMetric?: UserCountMetric
  onModalCloseClicked: () => void
}

const AudienceBreakoutModal: React.FC<Props> = props => {
  const {
    show,
    includeRecentlyRewarded,
    userCountMetric,
    onModalCloseClicked,
  } = props

  const data = userCountMetric?.data
  const subscribers = data?.subscriber_count || 0
  const loyaltyMembers = data?.member_count || 0

  let sections = [
    {
      title: t('targeted.title'),
      items: [
        {
          description: t('targeted.loyalty'),
          count: loyaltyMembers,
        },
        {
          description: t('targeted.subscriber'),
          count: subscribers,
        },
      ],
      id: 'targeted',
    },
  ]

  if (!includeRecentlyRewarded) {
    const excluded = data?.excluded_count || 0
    sections.push({
      title: t('excluded.title'),
      items: [
        {
          description: t('excluded.past_14_days'),
          count: excluded,
        },
      ],
      id: 'excluded',
    })
  }

  return (
    <AudienceBreakoutModalv3
      show={show}
      sections={sections}
      isLoading={userCountMetric?.isLoading}
      isErrored={userCountMetric?.isErrored}
      onModalCloseClicked={onModalCloseClicked}
    />
  )
}

export default AudienceBreakoutModal
